import { render } from "./ReservasiSuccess.vue?vue&type=template&id=7dcad626"
import script from "./ReservasiSuccess.vue?vue&type=script&lang=js"
export * from "./ReservasiSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__